import axios from 'axios'
import {
  Th3PostPreviewResponse,
  Th3PostImportResponse,
  Th3PostImportStatus,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL || ''
const TH3POST_URL = `${API_URL}/api/th3post-sync`

const getAuthToken = () => {
  const auth = localStorage.getItem('kt-auth-react-v')
  if (auth) {
    const parsed = JSON.parse(auth)
    return parsed.api_token
  }
  return null
}

const getAxios = () => {
  const token = getAuthToken()
  return axios.create({
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  })
}

export const th3postLogin = async (cookie: string): Promise<{success: boolean}> => {
  const api = getAxios()
  const response = await api.post<{success: boolean}>(`${TH3POST_URL}/login`, { cookie })
  return response.data
}

export const th3postPreview = async (): Promise<Th3PostPreviewResponse> => {
  const api = getAxios()
  const response = await api.get<Th3PostPreviewResponse>(`${TH3POST_URL}/preview`)
  return response.data
}

export const th3postImport = async (campaignIds?: string[]): Promise<Th3PostImportResponse> => {
  const api = getAxios()
  const response = await api.post<Th3PostImportResponse>(`${TH3POST_URL}/import`, { campaignIds })
  return response.data
}

export const th3postImportStatus = async (jobId: string): Promise<Th3PostImportStatus> => {
  const api = getAxios()
  const response = await api.get<Th3PostImportStatus>(`${TH3POST_URL}/import-status/${jobId}`)
  return response.data
}

export const th3postGetSavedCredentials = async (): Promise<{success: boolean; cookie: string; hasSaved: boolean}> => {
  const api = getAxios()
  const response = await api.get<{success: boolean; cookie: string; hasSaved: boolean}>(`${TH3POST_URL}/saved-credentials`)
  return response.data
}

export const th3postLogout = async (): Promise<{success: boolean}> => {
  const api = getAxios()
  const response = await api.post<{success: boolean}>(`${TH3POST_URL}/logout`)
  return response.data
}
